import axios from 'axios'
import { useAuthStore } from '../../../store/authStore'
import { buildLoginUrl } from '../../../utils/redirectTo'
import { refreshAccessToken } from '../utils/refreshToken'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor to add Bearer token to all requests
api.interceptors.request.use(
  (config) => {
    const { token, tokenType } = useAuthStore.getState()
    if (token) {
      config.headers.Authorization = `${tokenType} ${token}` // Add token and type to header
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Interceptor to handle response errors
api.interceptors.response.use(
  (response) => response, // Return response if no errors
  async (error) => {
    const originalRequest = error.config

    // If error is 401 and hasn't been retried
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true // Mark this request as retried

      try {
        const newToken = await refreshAccessToken() // Try to refresh the token
        if (newToken) {
          // Update Authorization header with the new token
          originalRequest.headers.Authorization = `${useAuthStore.getState().tokenType} ${newToken}`
          return api(originalRequest) // Retry the original request
        }
      } catch (refreshError) {
        console.error('Error refreshing token:', refreshError)
        useAuthStore.getState().clearToken() // Clear tokens if refresh fails
        window.location.href = buildLoginUrl() // Redirect to login
      }
    }

    return Promise.reject(error) // Propagate error if it couldn't be handled
  },
)
